module.exports = __webpack_public_path__ + "static/img/blog2.da91994.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/blog2.jpg
// module id = eFap
// module chunks = 0